import { errorHandler } from '@/app/shared/services/error-handler.js';
import {axiosWebApiInstance} from '@/app/shared/services/http-client/webApi.axios';
import i18n from '../../../i18n/i18n'

export default {

  Get (url, data, vm, config) {
    return new Promise((resolve, reject) => {
      axiosWebApiInstance.get(url, data, config)
        .then((response) => {
          this.handleSuccess(vm, response)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.cqrsError(vm, error);
          reject(error)
        })
    });
  },

  Post (url, data, vm, config) {
    return new Promise((resolve, reject) => {
      axiosWebApiInstance.post(url, data, config)
        .then((response) => {
          this.handleSuccess(vm, response)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.cqrsError(vm, error);
          reject(error)
        })
    });
  },

  Delete (url, data, vm, config) {
    return new Promise((resolve, reject) => {
      axiosWebApiInstance.delete(url, data, config)
        .then((response) => {
          this.handleSuccess(vm, response)
          resolve(response)
        })
        .catch((error) => {
          errorHandler.cqrsError(vm, error);
          reject(error)
        })
    });
  },

  handleSuccess(vm, response)  {
    if (response.data && response.data.success && response.data.messages && response.data.messages.length > 0) {
      const messages = response.data.messages.map(o => o.key).join('</br></br>');
      
      vm.$vs.notify({
        color: "primary",
        title: i18n.t("Info"),
        text: messages
      });
    }
  }
}